import React, {useState} from 'react';

import {SearchAccount} from 'src/components/account-information/components/search-account';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';

import type {AccountShortInfo} from 'src/openapi/admin/models/AccountShortInfo';

type Props = {
    onClose: () => void,
    accountId: number,
    onInherit: (parent: AccountShortInfo) => void,
    busy: boolean,
    canSetParent: boolean,
    error: string | null,
};

export const SsoSettingsInheritanceModal = ({onClose, accountId, onInherit, busy, canSetParent, error}: Props) => {
    const [parentAccount, setParentAccount] = useState<AccountShortInfo>();

    return (
        <>
            <DialogHeader onClose={busy ? undefined : onClose}>
                SSO Settings Inheritance
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                <Group direction="v">
                    <Message color="info">Select a parent account first to inherit its SSO settings.</Message>
                    {!canSetParent && <Message color="error">You do not have permission to set a parent account.</Message>}
                    {error ? <Message color="error">{error}</Message> : null}
                    <SearchAccount
                        label="Parent account"
                        placeholder="Enter account name"
                        selectedAccount={parentAccount}
                        onSelect={setParentAccount}
                        accountId={accountId}
                        width={500}
                        disabled={busy || !canSetParent}
                    />
                </Group>
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button
                        busy={busy}
                        variant="Type.PRIMARY"
                        disabled={busy || !parentAccount || !canSetParent}
                        onClick={() => parentAccount && onInherit(parentAccount)}>
                        Save and Inherit
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose} disabled={busy}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
